import { useBlocNext } from "@blac/react";
import { AuthenticationMethod } from "src/ui/components/WithAuth/WithAuthCubit";
import UserCubit from "src/state/UserCubit/UserCubit";
import UserPreferencesCubit from "src/state/UserPreferencesCubit/UserPreferencesCubit";
import { useBloc } from "src/state/state";

export interface NameFieldsLockedResult {
  locked: boolean;
  firstName?: string;
  lastName?: string;
}

/**
 * Returns whether the first/last name fields should be locked (read-only and
 * prefilled) because the member authenticated via Transcarent SSO and both
 * names are already set in their preferences.
 */
const useNameFieldsLocked = (): NameFieldsLockedResult => {
  const [{ userData }] = useBloc(UserCubit);
  const [, { firstName, lastName }] = useBlocNext(UserPreferencesCubit);

  const isTranscarentSso =
    userData?.sessionAuthenticationMethod ===
    AuthenticationMethod.TRANSCARENT_SSO;

  const locked = isTranscarentSso && Boolean(firstName) && Boolean(lastName);

  return { locked, firstName, lastName };
};

export default useNameFieldsLocked;
